export default __webpack_public_path__ + "static/media/murphy_sit_in.50e15e8b.png";